import { api } from '../../../services/api';

export class LinksService {
  constructor() {
    this.Api = api;
  }

  getEdits(publisherId, params) {
    return api.get(`/api/v2/publishers/${publisherId}/bulk_links/edits/`, params);
  }

  getEdit(publisherId, params) {
    return api.get(`/api/v2/publishers/${publisherId}/bulk_links/edit_by_id/`, params);
  }

  createStory(publisherId, params) {
    return api.post(`/api/v2/publishers/${publisherId}/bulk_links/edits/`, params);
  }

  editStory(publisherId, params) {
    return api.put(`/api/v2/publishers/${publisherId}/bulk_links/edits/`, params);
  }

  createLinks(publisherId, params) {
    return api.post(`/api/v2/publishers/${publisherId}/bulk_links/links/`, params);
  }

  getLinks(publisherId, params) {
    return api.get(`/api/v0/publishers/${publisherId}/link_management/list/`, params);
  }

  parseLinks(input) {
    return input.split('\n').filter(link => link !== '');
  }

  // manage link columns helper methods
  setMonetizeableColor(status) {
    const formattedStatus = status.toLowerCase();
    return formattedStatus === 'monetizeable'
      ? 'green'
      : formattedStatus === 'not monetizeable'
      ? 'dark-gray'
      : 'light-grey';
  }

  getMockData() {
    return {
      edits: [
        {
          edit_id: 100127,
          name: '10 Nail Strengtheners a Top Manicurist Relies On',
          url: 'https://www-byrdie-com.cdn.ampproject.org/',
          channel: 'youtube',
          datetime_created: '2021-05-30',
        },
        {
          edit_id: 100080,
          name: '4 Steps to Getting Rid of Cystic Acne - Article',
          url: 'https://www.allure.com/story/get-rid-of-cystic-acne-fast',
          channel: null,
          datetime_created: null,
        },
        {
          edit_id: 100081,
          name: 'How to Get Rid of Blackheads, According to Top Dermatologists',
          url: 'https://www.allure.com/story/how-to-get-rid-blackheads',
          channel: null,
          datetime_created: null,
        },
        {
          edit_id: 100082,
          name: 'NL Daily Deals',
          url: '',
          channel: null,
          datetime_created: null,
        },
      ],
      page_info: {
        next_page: true,
      },
    };
  }

  getManageLinksMockData() {
    const longLink =
      'http://bestbuy.7tiv.net/c/196318/614286/10014?u=https%3A%2F%2Fwww.bestbuy.com%2Fsite%2Flenovo-yoga-c940-2-in-1-14-touch-screen-laptop-intel-core-i7-12gb-memory-512gb-solid-state-drive-iron-gray%2F6367799.p%3FskuId%3D6367799&subid2=1600453881953akbrpawfd&nrtv=true';
    const link = 'https://narrativ-link/12345';
    const edits = [
      {
        bam_link_id: 1,
        edit_id: 1,
        edit_name: 'The Best Mens Skincare',
        // product_name: 'Beard Oil',
        bam_link_url: longLink,
        auction_url: link,
        encoded_auction_url: link,
        monetizeable_status: 'Loading Status...',
        edit_channel: 'Youtube',
        datetime_link_created: '2021-05-30',
        clipboard: 'some text',
      },
      {
        bam_link_id: 2,
        edit_id: 2,
        edit_name: 'Best Dogwear',
        product_name: 'Doggy Boots',
        bam_link_url: 'https://narrativ.com/',
        auction_url: link,
        encoded_auction_url: link,
        datetime_link_created: '2021-12-12',
        edit_channel: 'Instagram',
        monetizeable_status: 'Processing',
      },
      {
        bam_link_id: 3,
        edit_id: 3,
        edit_name: 'Fastest Internet',
        product_name: 'Super Router',
        bam_link_url: 'https://narrativ.com/',
        auction_url: link,
        encoded_auction_url: link,
        datetime_link_created: '2021-07-25',
        edit_channel: 'Facebook',
        monetizeable_status: 'Not Monetizeable',
      },
      {
        bam_link_id: 4,
        edit_id: 4,
        edit_name: 'Cool Wallets',
        product_name: 'Leather Wallet',
        bam_link_url: 'https://narrativ.com/',
        auction_url: link,
        encoded_auction_url: link,
        datetime_link_created: '2021-01-01',
        edit_channel: 'TikTok',
        monetizeable_status: 'Monetizeable',
      },
    ];
    return [...edits];
  }

  getMockPastedLinks() {
    let pastedLinks = 'http://fb.com\n\nhttp://fb.com\n\nhttp://blarf\n\nhttp:/sssss\n';
    for (let i = 0; i < 30; i++) {
      pastedLinks += `\n\nhttp://apple.com/${i}`;
    }
    return pastedLinks;
  }
}

export const linksService = new LinksService();
